"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WAITLIST_REQUEST_EXAMPLES = exports.expireWaitlistRequestSchema = exports.promoteWaitlistRequestSchema = exports.joinWaitlistRequestSchema = void 0;
/**
 * Request contracts for the 3 Waitlist endpoints. Field shapes mirror
 * `WaitlistApplicationService`'s own method input shapes (backend,
 * frozen, Stage 5B.4). `promoteWaitlist` maps to that service's
 * `promoteAndBook()` — the only promotion capability the Application
 * layer exposes (see `docs/APPOINTMENT-API-CONTRACT-GUIDE.md`'s note
 * on this naming).
 */
const zod_1 = require("zod");
const appointment_common_request_1 = require("./appointment-common.request");
exports.joinWaitlistRequestSchema = appointment_common_request_1.priorityTierInputSchema.extend({
    patientId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    doctorId: zod_1.z.string().uuid().optional(),
    desiredFromDate: zod_1.z.coerce.date(),
    desiredToDate: zod_1.z.coerce.date(),
});
const promoteWaitlistSlotSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    doctorId: zod_1.z.string().uuid().optional(),
    offeredSlotAt: zod_1.z.coerce.date(),
    offerWindowMs: zod_1.z.number().int().positive().optional(),
});
const promoteWaitlistBookingSchema = zod_1.z.object({
    bookingChannelId: zod_1.z.string().uuid(),
    clinicalPurposeId: zod_1.z.string().uuid().optional(),
    consultationMode: zod_1.z.enum(['IN_PERSON', 'TELEMEDICINE', 'HOME_VISIT']).optional(),
    payerContext: zod_1.z.enum(['GENERAL', 'CORPORATE', 'INSURANCE', 'PACKAGE']).optional(),
    durationMinutes: zod_1.z.number().int().positive(),
    priorityTier: zod_1.z.number().int().optional(),
    finTariffId: zod_1.z.string().uuid().optional(),
    finPackageId: zod_1.z.string().uuid().optional(),
    finPaymentId: zod_1.z.string().uuid().optional(),
    patientReferralId: zod_1.z.string().uuid().optional(),
});
exports.promoteWaitlistRequestSchema = zod_1.z.object({
    promote: promoteWaitlistSlotSchema,
    booking: promoteWaitlistBookingSchema,
});
/** An operational sweep, not a per-entry action. */
exports.expireWaitlistRequestSchema = zod_1.z.object({
    asOf: zod_1.z.coerce.date().optional(),
});
exports.WAITLIST_REQUEST_EXAMPLES = {
    joinWaitlist: {
        patientId: '11111111-1111-1111-1111-111111111111',
        branchId: '33333333-3333-3333-3333-333333333333',
        departmentId: '44444444-4444-4444-4444-444444444444',
        desiredFromDate: new Date('2026-08-01'),
        desiredToDate: new Date('2026-08-07'),
    },
    promoteWaitlist: {
        promote: {
            branchId: '33333333-3333-3333-3333-333333333333',
            departmentId: '44444444-4444-4444-4444-444444444444',
            doctorId: '22222222-2222-2222-2222-222222222222',
            offeredSlotAt: new Date('2026-08-01T10:00:00Z'),
        },
        booking: {
            bookingChannelId: '55555555-5555-5555-5555-555555555555',
            durationMinutes: 15,
        },
    },
    expireWaitlist: {},
};
//# sourceMappingURL=waitlist.request.js.map